import { useEffect, useRef } from 'react'

/**
 * Headless additive search provider stub for help articles.
 *
 * Implements the universal provider interface. The orchestrator renders this
 * as a sibling of the primary provider; its results are routed to
 * SupplementarySearchContext with providerId='help'.
 *
 * Replace the useEffect body with a real help search call (e.g. Algolia
 * Instantsearch on a help index, or a Zendesk / Intercom API call).
 *
 * Props:
 *   query     {string}   Controlled query from SearchOrchestrator.
 *   options   {Object}   Provider-agnostic options (hitsPerPage etc.).
 *   onResults {Function} Callback — called with the results shape.
 */
function HelpSearchProvider({
  query,
  options, // eslint-disable-line no-unused-vars
  onResults,
}) {
  // Ref so onResults identity changes do not retrigger the effect.
  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    onResultsRef.current({ hits: [] })
  }, [query])

  return null
}

export default HelpSearchProvider
